import React, { useState } from "react";
import "../StuStyles/Jobfairregister.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../../../nhrc_apis/ApiService";

const { JobFairAPI } = ApiService;

const StuLiveRegister = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const eventData = state?.event;

  console.log("EVENT DATA RECEIVED:", eventData);

  const [formData, setFormData] = useState({
    full_name:          "",
    phone:              "",
    email:              "",
    location:           "",
    iam_a:              "",
    nhrc_id:            "",
    college_name:       "",
    year_of_passout:    "",
    department:         "",
    preferred_job_role: "",
    technical_skills:   "",
    receive_updates:    false,
  });

  const [errors, setErrors]   = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);

  // ─── VALIDATE SINGLE FIELD ────────────────────────────────
  const validateField = (name, value) => {
    let error = "";

    switch (name) {

      case "full_name":
        if (!value || !value.trim()) {
          error = "Full name is required.";
        } else if (value.trim().length < 3) {
          error = "Full name must be at least 3 characters.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "Full name must contain only letters and spaces.";
        }
        break;

      case "phone":
        if (!value || !value.trim()) {
          error = "Mobile number is required.";
        } else if (!/^[0-9]{10}$/.test(value.trim())) {
          error = "Mobile number must be exactly 10 digits.";
        }
        break;

      case "email":
        if (!value || !value.trim()) {
          error = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          error = "Enter a valid email address (e.g. name@example.com).";
        }
        break;

      case "location":
        if (!value || !value.trim()) {
          error = "Location is required.";
        } else if (value.trim().length < 2) {
          error = "Location must be at least 2 characters.";
        }
        break;

      case "iam_a":
        if (!value || !value.trim()) {
          error = "This field is required.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "This field must contain only letters and spaces.";
        }
        break;

      case "nhrc_id":
        if (!value || !value.trim()) {
          error = "NHRC ID is required.";
        } else if (value.trim().length < 3) {
          error = "NHRC ID must be at least 3 characters.";
        }
        break;

      case "college_name":
        if (!value || !value.trim()) {
          error = "College name is required.";
        } else if (value.trim().length < 3) {
          error = "College name must be at least 3 characters.";
        }
        break;

      case "year_of_passout":
        if (!value || !value.trim()) {
          error = "Year of pass out is required.";
        } else if (!/^[0-9]{4}$/.test(value.trim())) {
          error = "Enter a valid 4-digit year (e.g. 2025).";
        } else if (
          parseInt(value.trim()) < 1980 ||
          parseInt(value.trim()) > 2035
        ) {
          error = "Year must be between 1980 and 2035.";
        }
        break;

      case "department":
        if (!value || !value.trim()) {
          error = "Department is required.";
        } else if (value.trim().length < 2) {
          error = "Department must be at least 2 characters.";
        }
        break;

      case "preferred_job_role":
        if (!value || !value.trim()) {
          error = "Preferred job role is required.";
        } else if (value.trim().length < 2) {
          error = "Preferred job role must be at least 2 characters.";
        }
        break;

      case "technical_skills":
        if (!value || !value.trim()) {
          error = "Technical skills are required.";
        } else if (value.trim().length < 5) {
          error = "Please enter at least 5 characters for technical skills.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  // ─── VALIDATE ALL FIELDS ──────────────────────────────────
  const validateAll = () => {
    const fields = [
      "full_name", "phone", "email", "location",
      "iam_a", "nhrc_id", "college_name", "year_of_passout",
      "department", "preferred_job_role", "technical_skills",
    ];

    const newErrors  = {};
    const newTouched = {};

    fields.forEach((field) => {
      newTouched[field] = true;
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    setTouched(newTouched);
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ─── HANDLE CHANGE ────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({ ...prev, [name]: newValue }));

    if (name !== "receive_updates") {
      const error = validateField(name, newValue);
      setErrors((prev)  => ({ ...prev, [name]: error }));
      setTouched((prev) => ({ ...prev, [name]: true  }));
    }
  };

  // ─── HANDLE RESET ─────────────────────────────────────────
  const handleReset = () => {
    setFormData({
      full_name:          "",
      phone:              "",
      email:              "",
      location:           "",
      iam_a:              "",
      nhrc_id:            "",
      college_name:       "",
      year_of_passout:    "",
      department:         "",
      preferred_job_role: "",
      technical_skills:   "",
      receive_updates:    false,
    });
    setErrors({});
    setTouched({});
  };

  // ─── HANDLE SUBMIT ────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isValid = validateAll();

    if (!isValid) {
      toast.error("Please fill all required fields correctly.", { autoClose: 2000 });
      return;
    }

    const payload = {
      job_fair_id:        eventData?.id || eventData?.job_fair_id || 0,
      full_name:          formData.full_name.trim(),
      email:              formData.email.trim(),
      phone:              formData.phone.trim(),
      location:           formData.location.trim(),
      iam_a:              formData.iam_a.trim(),
      nhrc_id:            formData.nhrc_id.trim(),
      college_name:       formData.college_name.trim(),
      year_of_passout:    formData.year_of_passout.trim(),
      department:         formData.department.trim(),
      preferred_job_role: formData.preferred_job_role.trim(),
      technical_skills:   formData.technical_skills.trim(),
      receive_updates:    formData.receive_updates,
    };

    console.log("FINAL PAYLOAD SENDING TO API:", payload);

    setLoading(true);
    try {
      const response = await JobFairAPI.registerStudentForJobFair(payload);
      console.log("API RESPONSE:", response);
      toast.success("Student Registered Successfully!", { autoClose: 2000 });
      setTimeout(() => {
        navigate("/student/LiveEvents");
      }, 2000);

    } catch (err) {
      console.error("Registration error:", err);

      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;

      if (status === 422 && Array.isArray(detail)) {
        const firstError = detail[0];
        const field = firstError?.loc?.[1] || "field";
        const msg   = firstError?.msg       || "Validation error";
        toast.error(`Validation error — ${field}: ${msg}`, { autoClose: 3500 });

      } else if (status === 401) {
        toast.error("Session expired. Please login again.", { autoClose: 2500 });
        setTimeout(() => navigate("/login"), 2600);

      } else if (status === 409) {
        toast.error("You have already registered for this job fair!", { autoClose: 2500 });

      } else if (typeof detail === "string") {
        toast.error(detail, { autoClose: 2500 });

      } else {
        toast.error(
          err?.response?.data?.message || "Registration failed. Please try again.",
          { autoClose: 2500 }
        );
      }

    } finally {
      setLoading(false);
    }
  };

  // ─── RENDER ───────────────────────────────────────────────
  return (
    <>
      <div className="stu-live-pg-register-wrapper">
        <form
          className="stu-live-pg-register-card"
          onSubmit={handleSubmit}
          noValidate
        >

          {eventData && (
            <div className="justfity-content-center">
              <h3 className="stu-live-pg-register-selected">
                <span>{eventData.title}</span>
              </h3>
              <h5 className="stu-live-pg-register-selected-date">
                <span>{eventData.date}</span>
              </h5>
            </div>
          )}

          <h2 className="stu-live-pg-register-title">REGISTER FORM</h2>

          <div className="stu-live-pg-register-grid">

            {/* Full Name */}
            <div className="stu-live-pg-register-field">
              <label>Full Name*</label>
              <input
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                placeholder="Enter your full name"
                className={errors.full_name ? "input-error" : ""}
              />
              {errors.full_name && <span className="error-text">{errors.full_name}</span>}
            </div>

            {/* Mobile Number */}
            <div className="stu-live-pg-register-field">
              <label>Mobile Number*</label>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter 10-digit mobile number"
                maxLength={10}
                className={errors.phone ? "input-error" : ""}
              />
              {errors.phone && <span className="error-text">{errors.phone}</span>}
            </div>

            {/* Email */}
            <div className="stu-live-pg-register-field">
              <label>Email Id*</label>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            {/* Location */}
            <div className="stu-live-pg-register-field">
              <label>Location*</label>
              <input
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter your location"
                className={errors.location ? "input-error" : ""}
              />
              {errors.location && <span className="error-text">{errors.location}</span>}
            </div>

            {/* I am a */}
            <div className="stu-live-pg-register-field stu-live-pg-register-pincode">
              <label>I am a*</label>
              <input
                name="iam_a"
                value={formData.iam_a}
                onChange={handleChange}
                placeholder="e.g. Student, Professional"
                className={errors.iam_a ? "input-error" : ""}
              />
              {errors.iam_a && <span className="error-text">{errors.iam_a}</span>}
            </div>

            {/* NHRC ID */}
            <div className="stu-live-pg-register-field">
              <label>NHRC ID*</label>
              <input
                name="nhrc_id"
                value={formData.nhrc_id}
                onChange={handleChange}
                placeholder="Enter your NHRC ID"
                className={errors.nhrc_id ? "input-error" : ""}
              />
              {errors.nhrc_id && <span className="error-text">{errors.nhrc_id}</span>}
            </div>

            {/* College Name */}
            <div className="stu-live-pg-register-field">
              <label>College Name*</label>
              <input
                name="college_name"
                value={formData.college_name}
                onChange={handleChange}
                placeholder="Enter your college name"
                className={errors.college_name ? "input-error" : ""}
              />
              {errors.college_name && <span className="error-text">{errors.college_name}</span>}
            </div>

            {/* Year of Passout */}
            <div className="stu-live-pg-register-field">
              <label>Year of Passout*</label>
              <input
                name="year_of_passout"
                value={formData.year_of_passout}
                onChange={handleChange}
                placeholder="e.g. 2025"
                maxLength={4}
                className={errors.year_of_passout ? "input-error" : ""}
              />
              {errors.year_of_passout && <span className="error-text">{errors.year_of_passout}</span>}
            </div>

            {/* Department */}
            <div className="stu-live-pg-register-field">
              <label>Department*</label>
              <input
                name="department"
                value={formData.department}
                onChange={handleChange}
                placeholder="Enter your department"
                className={errors.department ? "input-error" : ""}
              />
              {errors.department && <span className="error-text">{errors.department}</span>}
            </div>

            {/* Preferred Job Role */}
            <div className="stu-live-pg-register-field">
              <label>Preferred Job Role*</label>
              <input
                name="preferred_job_role"
                value={formData.preferred_job_role}
                onChange={handleChange}
                placeholder="Enter preferred job role"
                className={errors.preferred_job_role ? "input-error" : ""}
              />
              {errors.preferred_job_role && <span className="error-text">{errors.preferred_job_role}</span>}
            </div>

          </div>

          {/* Technical Skills */}
          <div className="stu-live-pg-register-field">
            <label>Technical Skills*</label>
            <textarea
              name="technical_skills"
              value={formData.technical_skills}
              onChange={handleChange}
              placeholder="e.g. React, Python, SQL"
              className={errors.technical_skills ? "input-error" : ""}
              style={{ width: "100%", height: "70px" }}
            />
            {errors.technical_skills && <span className="error-text">{errors.technical_skills}</span>}
          </div>

          {/* Checkbox */}
          <div className="stu-live-pg-register-checkbox">
            <p>Would you like to receive updates about future events and professional opportunities? *</p>
            <input
              type="checkbox"
              name="receive_updates"
              checked={formData.receive_updates}
              onChange={handleChange}
              className="check-lve"
            />
          </div>

          {/* Buttons */}
          <div className="stu-live-pg-register-buttons">
            <button
              type="button"
              className="stu-live-pg-register-reset"
              onClick={handleReset}
              disabled={loading}
            >
              Clear
            </button>
            <button
              type="submit"
              className="stu-live-pg-register-submit"
              disabled={loading}
            >
              {loading ? "Submitting..." : "SUBMIT"}
            </button>
          </div>

        </form>
      </div>

      <ToastContainer position="top-center" />
    </>
  );
};

export default StuLiveRegister;